import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { toCivilDate } from './civil-date';

/**
 * Like the `date` pipe, but date-only values and UTC-midnight timestamps are
 * shown on their calendar day instead of shifting a day earlier in US time zones.
 * Usage: {{ st.date | civilDate:'MM/dd/yyyy' }}
 */
@Pipe({ name: 'civilDate' })
export class CivilDatePipe implements PipeTransform {
  private datePipe: DatePipe;

  constructor(@Inject(LOCALE_ID) locale: string) {
    this.datePipe = new DatePipe(locale);
  }

  transform(value: any, format: string = 'mediumDate'): string | null {
    const date = toCivilDate(value);
    return date ? this.datePipe.transform(date, format) : null;
  }
}
